var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { addWeeks, endOfMonth, format, isSameDay, isWeekend, isSameMonth, setDay, startOfMonth, parseISO, } from 'date-fns';
export var createWeek = function (_a) {
    var date = _a.date, baseMonth = _a.baseMonth, pattern = _a.pattern, weekStartsOn = _a.weekStartsOn, holyDays = _a.holyDays;
    var week = [];
    var dayOfWeek = 0;
    var isFirstWeek = false;
    var isLastWeek = false;
    var _loop_1 = function () {
        var day = setDay(date, dayOfWeek, { weekStartsOn: weekStartsOn });
        var formattedDate = pattern
            ? parseISO(format(day, pattern, { weekStartsOn: weekStartsOn }))
            : day;
        var holyDay = holyDays === null || holyDays === void 0 ? void 0 : holyDays.find(function (mapHolyDay) {
            return isSameDay(mapHolyDay.date, day);
        });
        var objToAdd = __assign({ date: formattedDate, isSameDay: isSameDay(new Date(), day), isSameMonth: isSameMonth(baseMonth, day), isWeekend: isWeekend(day) }, (holyDays ? { holyDay: holyDay, isHolyday: !!holyDay } : {}));
        week.push(objToAdd);
        if (!isFirstWeek)
            isFirstWeek = isSameDay(day, startOfMonth(baseMonth));
        if (!isLastWeek)
            isLastWeek = isSameDay(day, endOfMonth(baseMonth));
        dayOfWeek += 1;
    };
    while (dayOfWeek < 7) {
        _loop_1();
    }
    return {
        isFirstWeek: isFirstWeek,
        isLastWeek: isLastWeek,
        week: week,
    };
};
export var createMonthMatrix = function (_a) {
    var year = _a.year, month = _a.month, pattern = _a.pattern, _b = _a.weekStartsOn, weekStartsOn = _b === void 0 ? 0 : _b, holyDays = _a.holyDays;
    var matrix = [];
    var baseMonth = new Date(year, month, 1);
    var dateToWeek = baseMonth;
    var isLastWeek = false;
    do {
        var createdWeek = createWeek({
            date: dateToWeek,
            baseMonth: baseMonth,
            pattern: pattern,
            weekStartsOn: weekStartsOn,
            holyDays: holyDays,
        });
        dateToWeek = addWeeks(dateToWeek, 1);
        matrix.push(createdWeek.week);
        isLastWeek = createdWeek.isLastWeek;
    } while (!isLastWeek);
    return matrix;
};
